import React from 'react';
import PropTypes from 'prop-types';
import './ChatTitle.css';
import chatBubbles from 'images/chat-bubbles.png';

export default function ChatTitle(props) {
  const { name } = props;

  return (
    <div className="chat-title">
      <h4>
        Chat
        <img className="chat-bubbles" src={chatBubbles} alt="chat-bubbles" />
      </h4>
      <div>
        This chat is just for clarification.
        <br />
        Any official response must be entered in the {name}.
      </div>
    </div>
  );
}

ChatTitle.propTypes = {
  name: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/shared/chat/ChatTitle.js